import styled from "styled-components";

export const GalleryWrapper = styled.div`
  display: none;
`;
